import type { Answers } from "../shared";

export type Profile = {
	title: string;
	text: string;
};

const CHAOS: Profile = {
	title: "Schwerelos im Papierchaos",
	text: "Alles schwebt irgendwo – im Postfach, im Ordner, auf dem Handy. Die gute Nachricht: Genau darum geht es heute.",
};

const MISSION_CONTROL: Profile = {
	title: "Mission Control",
	text: "Ihr Dokumenten-Universum läuft nach Plan. Heute holen Sie sich Ideen, wie KI Ihren Dokumenten noch mehr Zusammenhang gibt.",
};

const LAUNCH_PAD: Profile = {
	title: "Startklar auf der Rampe",
	text: "Die Neugier ist da, der Countdown läuft. Heute gibt es die Checkliste, damit der Start sauber gelingt.",
};

const ORBIT: Profile = {
	title: "Stabil im Orbit",
	text: "Es läuft – meistens. Mit etwas mehr Struktur wird aus „liegt irgendwo“ ein „sofort gefunden“.",
};

/** A light-hearted "Ablage-Typ" from the mood, DMS and AI answers. */
export function profileFor(answers: Answers): Profile {
	const mood = answers.stimmung?.[0];
	const dms = answers.dms?.[0];
	const ai = answers.ki?.[0];

	if (mood === "chaos" || mood === "brennt") {
		return CHAOS;
	}
	if ((mood === "im-griff" || mood === "meistens") && dms === "ja-gut") {
		return MISSION_CONTROL;
	}
	if (ai && ai !== "bewusst-nicht" && dms !== "ja-gut") {
		return LAUNCH_PAD;
	}
	return ORBIT;
}
